export const CONTENT_TYPE = {
  //---技术支持---
  11: 'APP下载',
  12: 'API文档',
  13: '常见问题',
  14: '使用教程',
  //---关于我们---
  21: '关于ALPHA',
  22: '白皮书',
  23: '官方公告',
  24: '上币申请',
  //---条款说明---
  31: '用户条款',
  32: '服务协议',
  33: '费率说明',
  34: '法律声明',
  35: 'C2C操作说明',
  //投票规则
  41: '投票规则',
  42: '预测规则',
  //借贷宝服务协议
  51: '借贷宝协议',
  //代理商服务协议
  61: '代理商服务协议'
};
